import {
    CREATE_PROJECT,
    SEARCH_PROJECT,
    UPDATE_PROJECT,
    PROJECT_PRICING,
    INFRA_ID_FOR_VALET,
    VALET_MONTHLY_DATA,
    CALCULATE_SALARY,
    DAILY_SALARY_DISTRIBUTION,
    MARK_HOLIDAYS_FOR_VALET,
    UPDATE_SALARY_STATUS,
    ALL_RAISED_TICKETS,
    ALL_ABSCOND_DRIVERS,
    RELEASE_ABSCOND_DRIVERS,
    APPROVE_ABSCOND_DRIVERS,
    RESPOND_VALET_OPS,
    STATUS_UPDATE_BY_VALET_HEAD,
    PENALTY_LISTING,
    GET_EVENT_SALARY,
    APPROVE_EVENT_SALARY,
    MASTER_SALARY_PENALTY, MASTER_SALARY_PENALTY_LIST, SALARY_BY_PHONE_NO,
    ADVANCE_SALARY_LIST, ADVANCE_SALARY_CALCULATE, ADVANCE_SALARY_UPDATE
} from "./type";
import {advanceSalaryListingRequest, salaryByPhone} from "./action";

const initalState = {
    projectRes: null,
    searchProjectRes: {},
    projectPricing : [],
    InfraIdList: [],
    getValetMonthlyList: [],
    calulateSalary: [],
    getDailySalaryDistribution: [],
    valetHolidaysMark: [],
    salaryStatusUpdate: [],
    allRaisedTicketsList: [],
    allAbscondDriverList: [],
    updateSalaryStatus: [],
    releaseSalary: [],
    getResponseFromValetOps: [],
    statusUpdate: [],
    eventSalaryList:[],
    approveSalary:[],
    penaltyList:[],
    masterSalaryPenaltyResponse:[],
    masterSalaryPenaltyListResponse:[],
    salaryByPhoneResponse:[],
    advanceSalaryListResponse: [],
    advanceSalaryCalculateResponse: [],
    advanceSalaryUpdateResponse: []
};

const CreateProject = (state = initalState, action) => {
    const { type, payload } = action;
    switch (type) {
        case CREATE_PROJECT:
            return {
                ...state,
                projectRes: payload
            };
        case SEARCH_PROJECT:
            return {
                ...state,
                searchProjectRes: payload.response.data,
            };
        case UPDATE_PROJECT:
            return {
                ...state,
                projectRes: payload,
            };
        case PROJECT_PRICING:
            return {
                ...state,
                projectPricing: payload.response.data,
            };
        case INFRA_ID_FOR_VALET:
            return {
                ...state,
                InfraIdList: payload.response.data,
            };
        case VALET_MONTHLY_DATA:
            return {
                ...state,
                getValetMonthlyList: payload.response.data,
            };
        case CALCULATE_SALARY:
            return {
                ...state,
                calulateSalary: payload.response.data,
            };
        case DAILY_SALARY_DISTRIBUTION:
            return {
                ...state,
                getDailySalaryDistribution: payload.response.data,
            };
        case MARK_HOLIDAYS_FOR_VALET:
            return {
                ...state,
                valetHolidaysMark: payload.response.data,
            };
        case UPDATE_SALARY_STATUS:
            return {
                ...state,
                salaryStatusUpdate: payload.response.data,
            };
        case ALL_RAISED_TICKETS:
            return {
                ...state,
                allRaisedTicketsList: payload.response.data,
            };
        case ALL_ABSCOND_DRIVERS:
            return {
                ...state,
                allAbscondDriverList: payload.response.data,
            };
        case RELEASE_ABSCOND_DRIVERS:
            return {
                ...state,
                releaseSalary: payload.response.data,
            };
        case APPROVE_ABSCOND_DRIVERS:
        return {
            ...state,
            updateSalaryStatus: payload.response.data,
        };
        case RESPOND_VALET_OPS:
            return {
                ...state,
                getResponseFromValetOps: payload.response.data,
            };
        case STATUS_UPDATE_BY_VALET_HEAD:
            return {
                ...state,
                statusUpdate: payload.response.data,
            };
        case GET_EVENT_SALARY:
            return {
                ...state,
                eventSalaryList: payload,
            };
        case APPROVE_EVENT_SALARY:
            return {
                ...state,
                approveSalary: payload.response.data,
            };
        case PENALTY_LISTING:
            return {
                ...state,
                penaltyList: payload?.response?.data,
            };
        case MASTER_SALARY_PENALTY:
            return {
                ...state,
                masterSalaryPenaltyResponse: payload?.response?.data,
            };
        case MASTER_SALARY_PENALTY_LIST:
            return {
                ...state,
                masterSalaryPenaltyListResponse: payload?.response?.data,
            };
        case SALARY_BY_PHONE_NO:
            return {
                ...state,
                salaryByPhoneResponse: payload?.response?.data,
            };
        case ADVANCE_SALARY_LIST:
            return {
                ...state,
                advanceSalaryListResponse: payload,
            };
        case ADVANCE_SALARY_CALCULATE:
            return {
                ...state,
                advanceSalaryCalculateResponse: payload,
            };
        case ADVANCE_SALARY_UPDATE:
            return {
                ...state,
                advanceSalaryUpdateResponse: payload,
            };
        default:
            return {
                ...state,
            };
    }
};

export default CreateProject;
